module.exports = __webpack_public_path__ + "img/call.06ed0c85.svg";